import { createComposable, createMapper, Module } from 'vuex-smart-module';

import PollsActions from './actions';
import PollsGetters from './getters';
import PollsMutations from './mutations';
import PollsState from './state';

const module = new Module({
  actions: PollsActions,
  getters: PollsGetters,
  mutations: PollsMutations,
  namespaced: true,
  state: PollsState,
});

export default module;

export const pollsStoreMapper = createMapper(module);
export const usePollsStore = createComposable(module);
